import styled from "styled-components";

export const DashboardContainer = styled.div`
  min-height: 100vh;
  background: #e1e1e1;
  padding: 20px;
  direction: rtl;
`;

export const Header = styled.header`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Avatar = styled.div`
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Greeting = styled.span`
  font-size: 0.9rem;
  color: #666;
`;

export const WelcomeText = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
`;

export const SectorBadge = styled.span`
  font-size: 0.8rem;
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
  padding: 4px 12px;
  border-radius: 20px;
  margin-top: 4px;
  display: inline-block;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const Button = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;

  ${props => props.variant === 'primary' && `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
  `}

  ${props => props.variant === 'secondary' && `
    background: #f8f9fa;
    color: #333;
    border: 1px solid #e9ecef;
    &:hover {
      background: #e9ecef;
    }
  `}

  ${props => props.variant === 'danger' && `
    background: transparent;
    color: #e74c3c;
    border: 1px solid #e74c3c;
    &:hover {
      background: #e74c3c;
      color: white;
    }
  `}

  ${props => props.variant === 'success' && `
    background: #27ae60;
    color: white;
    &:hover {
      background: #219a52;
    }
  `}

  ${props => props.variant === 'warning' && `
    background: #f39c12;
    color: white;
    &:hover {
      background: #d68910;
    }
  `}
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const StatNumber = styled.span`
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #333;
`;

export const StatLabel = styled.span`
  font-size: 0.85rem;
  color: #666;
`;

export const ProgressSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
`;

export const ProgressRing = styled.div`
  position: relative;
  width: 140px;
  height: 140px;

  svg {
    transform: rotate(-90deg);
    width: 100%;
    height: 100%;
  }

  .ring-bg {
    fill: none;
    stroke: #e9ecef;
    stroke-width: 10;
  }

  .ring-fill {
    fill: none;
    stroke: url(#gradient);
    stroke-width: 10;
    stroke-linecap: round;
    transition: stroke-dasharray 0.5s ease;
  }
`;

export const RingText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

export const RingNumber = styled.span`
  display: block;
  font-size: 1.8rem;
  font-weight: 700;
  color: #667eea;
`;

export const RingLabel = styled.span`
  font-size: 0.8rem;
  color: #666;
`;

export const ProgressDetails = styled.div`
  h3 {
    margin: 0 0 8px;
    font-size: 1.2rem;
    color: #333;
  }

  p {
    margin: 0;
    color: #666;
    font-size: 0.95rem;
  }
`;

export const PendingMessage = styled.p`
  color: #f39c12 !important;
  font-weight: 500;
  margin-top: 8px !important;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background: white;
  padding: 8px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const Tab = styled.button`
  flex: 1;
  padding: 12px 24px;
  background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent'};
  color: ${props => props.active ? 'white' : '#666'};
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.active ? '' : '#f8f9fa'};
  }
`;

export const CoursesSection = styled.section`
  margin-bottom: 30px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 20px;
`;

export const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

export const CourseCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  border-right: 4px solid ${props => {
    switch(props.status) {
      case 'completed': return '#27ae60';
      case 'in_progress': return '#3498db';
      case 'failed': return '#e74c3c';
      default: return '#f39c12';
    }
  }};
`;

export const CourseStatus = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${props => props.color}20;
  color: ${props => props.color};
  margin-bottom: 12px;
`;

export const CourseTitle = styled.h3`
  font-size: 1.1rem;
  color: #333;
  margin: 0 0 8px;
`;

export const CourseDescription = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin: 0 0 16px;
  line-height: 1.5;
`;

export const ProgressBar = styled.div`
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
  width: ${props => props.width || 0}%;
  transition: width 0.3s ease;
`;

export const ProgressText = styled.span`
  font-size: 0.8rem;
  color: #666;
`;

export const CourseMeta = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  font-size: 0.8rem;
  color: #999;
`;

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }
`;

export const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns || '1fr'};
  gap: 10px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const EmptyIcon = styled.span`
  font-size: 4rem;
  display: block;
  margin-bottom: 16px;
`;

export const ExamStats = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 30px;
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const ExamStat = styled.div`
  text-align: center;
`;

export const ExamStatNumber = styled.span`
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: ${props => props.color || '#333'};
`;

export const ExamStatLabel = styled.span`
  font-size: 0.85rem;
  color: #666;
`;

export const MaxAttempts = styled.div`
  text-align: center;
  padding: 12px;
  background: #fee2e2;
  color: #991b1b;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
`;

export const LoadingMessage = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
`;